import type { MergedGpEventResponse } from "../types";
import { _ } from "i18n";
import type { Keys } from "i18n/locales/types";

export const getClipLabel = (mergedEvent: MergedGpEventResponse): string => {
	const minuteLabel = mergedEvent.footballTime === null ? "" : `${Math.floor(mergedEvent.footballTime / 60000)}'`;
	const eventType = mergedEvent.types[0];
	const eventTypeLabel = eventType === undefined ? "" : _(`event.v3.type.${eventType}` as keyof Keys);

	if (minuteLabel === "") {
		return eventTypeLabel;
	}

	if (eventTypeLabel === "") {
		return minuteLabel;
	}

	return `${minuteLabel} ${eventTypeLabel}`;
};
